/**
 * WebMCP tools of the public site, as an inline head script (the root route adds it to public
 * pages). Inline and synchronous, not a React effect: agents and scanners read the registered
 * tools at page load, sometimes before hydration. It polls for the API because a browser agent
 * may inject `document.modelContext` (older Chrome: `navigator.modelContext`) after the page
 * starts. Runs once per page: the router may append the script again after hydration.
 *
 * Every tool does what it says with what the site already serves: the sitemap, each page's
 * Markdown (`Accept: text/markdown`, app/ssr.tsx) and plain navigation. Nothing is submitted.
 */
export const webMcpScript = `(function () {
  if (typeof window === "undefined" || window.__hephonWebMcp) return;
  window.__hephonWebMcp = true;
  function text(t) { return { content: [{ type: "text", text: t }] }; }
  function samePath(p) {
    if (typeof p !== "string" || p.charAt(0) !== "/" || p.charAt(1) === "/") throw new Error("Give a path on this site, starting with /");
    return p;
  }
  function pages() {
    return fetch("/sitemap.xml").then(function (r) { return r.text(); }).then(function (xml) {
      var out = [], re = /<loc>([^<]+)<\\/loc>/g, m;
      while ((m = re.exec(xml))) out.push(new URL(m[1]).pathname);
      return out;
    });
  }
  var none = { type: "object", properties: {}, additionalProperties: false };
  var pathInput = { type: "object", properties: { path: { type: "string", description: "A page path on this site, like /how-it-works" } }, required: ["path"], additionalProperties: false };
  var tools = [
    {
      name: "list_pages",
      description: "List the pages of the Hephon Commerce website (the AI shopping assistant for supermarkets and retailers), from its sitemap.",
      inputSchema: none,
      annotations: { readOnlyHint: true },
      execute: function () { return pages().then(function (p) { return text(p.join("\\n")); }); }
    },
    {
      name: "read_page",
      description: "Read one page of the Hephon Commerce website as Markdown, without navigating away.",
      inputSchema: pathInput,
      annotations: { readOnlyHint: true },
      execute: function (input) {
        return fetch(samePath(input && input.path), { headers: { accept: "text/markdown" } }).then(function (r) { return r.text(); }).then(text);
      }
    },
    {
      name: "open_page",
      description: "Open a page of the Hephon Commerce website in this tab.",
      inputSchema: pathInput,
      execute: function (input) { var p = samePath(input && input.path); window.location.assign(p); return text("Opening " + p); }
    },
    {
      name: "book_demo",
      description: "Open the page where a retailer books a demo of Hephon Commerce on its own catalog. The visitor fills in and sends the form.",
      inputSchema: none,
      execute: function () { window.location.assign("/demo"); return text("Opening the demo booking page."); }
    }
  ];
  var done = false;
  function register() {
    if (done) return;
    var mc = (typeof document !== "undefined" && document.modelContext) || navigator.modelContext;
    if (!mc || typeof mc.registerTool !== "function") return;
    done = true;
    for (var i = 0; i < tools.length; i++) {
      try { Promise.resolve(mc.registerTool(tools[i])).catch(function () {}); } catch (e) {}
    }
  }
  register();
  var n = 0;
  var timer = setInterval(function () { register(); if (done || ++n > 60) clearInterval(timer); }, 200);
  document.addEventListener("DOMContentLoaded", register);
  window.addEventListener("load", register);
})();`;
